import { useContext, useEffect, useRef } from 'react';
import { useForm } from 'react-final-form';
import DealRoomFieldsRequiredVisibleInfoContext from '../providers/DealRoomFieldsRequiredVisibleInfo/DealRoomFieldsRequiredVisibleInfo.context';
import {
  getIsDealRoomDefaultRequired,
  DealRoomFieldBaseName,
} from 'router/data/dealRoomDefaultRequired';
import { REQUIRED_VISIBLE_INFO } from 'data/global';

export default function useDealRoomFieldIsRequired(
  fieldName: DealRoomFieldBaseName,
) {
  const { fields } = useContext(DealRoomFieldsRequiredVisibleInfoContext);

  const key = `${fieldName}${REQUIRED_VISIBLE_INFO}` as const;

  const isDefaultRequired = getIsDealRoomDefaultRequired(fieldName);

  const isRequired = fields?.[key]?.isRequired ?? isDefaultRequired;

  const form = useForm();

  const prevIsRequired = useRef(isRequired);

  useEffect(() => {
    if (prevIsRequired.current === isRequired) return;
    prevIsRequired.current = isRequired;

    form.resetFieldState(fieldName);
  }, [isRequired, form, fieldName]);

  return [isRequired, isDefaultRequired];
}
